module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "m-l-50 m-t-30"
  }, [_c('common-config', {
    attrs: {
      "id": _vm.id,
      "form": _vm.form,
      "inputList": _vm.inputList,
      "isLimit": false
    }
  }, [_c('template', {
    slot: "self-config"
  }, [_c('div', {
    staticClass: "m-b-10 p-20 bor-ccc pos-rel"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("收信配置")]), _vm._v(" "), _c('div', [_c('el-form-item', {
    attrs: {
      "label": "选择邮箱字段"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email_fieldId),
      expression: "form.email_fieldId"
    }],
    attrs: {
      "filterable": ""
    },
    domProps: {
      "value": (_vm.form.email_fieldId)
    },
    on: {
      "input": function($event) {
        _vm.form.email_fieldId = $event
      }
    }
  }, _vm._l((_vm.inputList), function(option, index) {
    return _c('el-option', {
      attrs: {
        "label": option.default.name + '(' + option.default.title + ')',
        "value": option.default.field_id
      }
    })
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "m-b-10 p-20 bor-ccc pos-rel"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("发信配置")]), _vm._v(" "), _c('div', [_c('el-form-item', {
    attrs: {
      "label": "发件服务器"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.smtp_host),
      expression: "form.smtp_host",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "w-200",
    domProps: {
      "value": (_vm.form.smtp_host)
    },
    on: {
      "input": function($event) {
        _vm.form.smtp_host = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "端口"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.smtp_port),
      expression: "form.smtp_port",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "w-200",
    domProps: {
      "value": (_vm.form.smtp_port)
    },
    on: {
      "input": function($event) {
        _vm.form.smtp_port = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账号"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.smtp_user),
      expression: "form.smtp_user",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "w-200",
    domProps: {
      "value": (_vm.form.smtp_user)
    },
    on: {
      "input": function($event) {
        _vm.form.smtp_user = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.smtp_pass),
      expression: "form.smtp_pass",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "w-200",
    domProps: {
      "value": (_vm.form.smtp_pass)
    },
    on: {
      "input": function($event) {
        _vm.form.smtp_pass = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发件人"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.send_person),
      expression: "form.send_person",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "w-200",
    domProps: {
      "value": (_vm.form.send_person)
    },
    on: {
      "input": function($event) {
        _vm.form.send_person = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "m-b-10 p-20 bor-ccc pos-rel"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("内容中的变量配置")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-tips"
  }, [_vm._v("变量公式说明：Y代表年，M代表月，D代表天，H代表时，I代表分，S代表秒，+1代表往前加一个单位，-1代表往后减一个单位，支持小数；可使用&进行多公式连接。例：D+1代表明天，M+1代表下个月，H+1代表一个小时后，I+10代表十分钟后，S+30代表30秒后")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.form.params
    }
  }, [_c('el-table-column', {
    staticStyle: {
      "width": "23%"
    },
    attrs: {
      "label": "标签名称"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model.trim",
            value: (scope.row.name),
            expression: "scope.row.name",
            modifiers: {
              "trim": true
            }
          }],
          domProps: {
            "value": (scope.row.name)
          },
          on: {
            "input": function($event) {
              scope.row.name = (typeof $event === 'string' ? $event.trim() : $event)
            },
            "blur": function($event) {
              _vm.$forceUpdate()
            }
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "width": "23%"
    },
    attrs: {
      "label": "内容变量标签"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('span', [_vm._v(" " + _vm._s(scope.row.param) + " ")])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "width": "23%"
    },
    attrs: {
      "label": "变量类型"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.type),
            expression: "scope.row.type"
          }],
          attrs: {
            "filterable": ""
          },
          domProps: {
            "value": (scope.row.type)
          },
          on: {
            "input": function($event) {
              scope.row.type = $event
            }
          }
        }, _vm._l((_vm.typeOptions), function(option) {
          return _c('el-option', {
            attrs: {
              "label": option.name,
              "value": option.id
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "width": "23%"
    },
    attrs: {
      "label": "对应变量"
    },
    scopedSlots: {
      default: function(scope) {
        return [(scope.row.type == 20) ? _c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.value),
            expression: "scope.row.value"
          }],
          attrs: {
            "filterable": ""
          },
          domProps: {
            "value": (scope.row.value)
          },
          on: {
            "input": function($event) {
              scope.row.value = $event
            }
          }
        }, _vm._l((_vm.inputList), function(option, index) {
          return _c('el-option', {
            attrs: {
              "label": option.default.name + '(' + option.default.title + ')',
              "value": option.default.field_id
            }
          })
        })) : (scope.row.type == 30) ? _c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.value),
            expression: "scope.row.value"
          }],
          attrs: {
            "filterable": ""
          },
          domProps: {
            "value": (scope.row.value)
          },
          on: {
            "input": function($event) {
              scope.row.value = $event
            }
          }
        }, _vm._l((_vm.userInfo), function(option, index) {
          return _c('el-option', {
            attrs: {
              "label": option.field + '(' + option.title + ')',
              "value": option.field_id
            }
          })
        })) : _c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model.trim",
            value: (scope.row.value),
            expression: "scope.row.value",
            modifiers: {
              "trim": true
            }
          }],
          domProps: {
            "value": (scope.row.value)
          },
          on: {
            "input": function($event) {
              scope.row.value = (typeof $event === 'string' ? $event.trim() : $event)
            },
            "blur": function($event) {
              _vm.$forceUpdate()
            }
          }
        }), _vm._v(" "), _vm._v(" ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "width": "8%"
    },
    attrs: {
      "label": "操作"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.deleteParams(scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-t-10 tx-c"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addParams
    }
  }, [_vm._v("增加一个")])])])]), _vm._v(" "), _c('div', {
    staticClass: "m-b-10 p-20 bor-ccc pos-rel"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("模板内容配置")]), _vm._v(" "), _vm._l((_vm.form.templet), function(item, index) {
    return _c('div', {
      staticClass: "m-b-10 p-b-10 bor-b-ccc"
    }, [_c('el-form-item', {
      attrs: {
        "label": "标题"
      }
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (item.title),
        expression: "item.title",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "w-200",
      domProps: {
        "value": (item.title)
      },
      on: {
        "input": function($event) {
          item.title = (typeof $event === 'string' ? $event.trim() : $event)
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "内容"
      }
    }, [_c('honray-editor', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.content),
        expression: "item.content"
      }],
      attrs: {
        "id": 'iden_' + index,
        "height": 200,
        "uploadImgUrl": _vm.host + 'admin/upload',
        "uploadHeaders": _vm.header
      },
      domProps: {
        "value": (item.content)
      },
      on: {
        "input": function($event) {
          item.content = $event
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "m-t-10"
    }, [_c('el-button', {
      on: {
        "click": function($event) {
          _vm.deleteTemplet(index)
        }
      }
    }, [_vm._v("删除")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t-10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTemplet
    }
  }, [_vm._v("增加一个")])])], true), _vm._v(" ")])], true)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-407e0cfe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/abstract/dealConfig/emailConfig.vue
// module id = 1836
// module chunks = 2